import { createContext, ReactNode, useState } from "react";
import { createStore, StoreApi } from "zustand";

export type BillingType = "monthly" | "annual";

type AppState = {
  billing: BillingType;
};

type AppAction = {
  setBilling: (billing: BillingType) => void;
};

export type AppStore = AppState & AppAction;
export const AppStoreContext = createContext<StoreApi<AppStore> | null>(null);

export function AppStoreProvider(props: { children: ReactNode | ReactNode[]; initialValues: AppState }) {
  const [store] = useState(() =>
    createStore<AppStore>()(set => ({
      billing: props.initialValues.billing,
      setBilling: billing =>
        set(() => {
          return { billing };
        }),
    }))
  );

  return <AppStoreContext.Provider value={store}>{props.children}</AppStoreContext.Provider>;
}
